// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"DocumentTabContent_uploadButton__RtdJj","actions":"DocumentTabContent_actions__3-P5r"};